import { Injectable } from '@angular/core';
import { BehaviorSubject, firstValueFrom } from 'rxjs';
import { Study } from '@models/study.model';
import { Router } from '@angular/router';
import { LoggingService } from '@services/logging.service';
import { HttpClient } from '@angular/common/http';
import { StudyService } from './study.service';
import { StudyStatus, CompleteStatus, InProgressStatus } from '../mystudies/_study_constants';
import { Observable } from 'rxjs';
import { StudyStatusInfo } from '../models/studyStatusInfo.model';

@Injectable()
export class StudyDetailService {
  public study: Study;

  observableStudyStatus: BehaviorSubject<number>;

  constructor(private http: HttpClient, private router: Router, private logger: LoggingService, private studyService: StudyService) {
    this.observableStudyStatus = new BehaviorSubject<number>(null);
  }

  public getStudyStatus(): Observable<number> {
    return this.observableStudyStatus.asObservable();
  }

  studyStatusChanged() {
    this.observableStudyStatus.next(this.study.statusId);
  }

  public async updateStudyStatus(studyStatusInfo: StudyStatusInfo): Promise<void> {
    await firstValueFrom(this.http.put('api/study/updatestudystatus', studyStatusInfo)).catch((e) => {
      this.logger.httpError(this.constructor.name, 'UpdateStudyStatus', e);
    });
  }

  public async Save(): Promise<Study> {
    const study = await this.studyService.Save(this.study);
    this.study = study;
    this.studyStatusChanged();
    return study;
  }

  public async getIsStudyEligibleForComplete(studyId: number): Promise<boolean> {
    const result = <boolean>await firstValueFrom(this.http.get<boolean>(`/api/Study/GetIsStudyEligibleForComplete/${studyId}`)).catch((e) => {
      this.logger.httpError(this.constructor.name, 'getIsStudyEligibleForComplete', e);
    });
    return result;
  }

  public SaveStudyStatus(): Study {
    if (this.study.statusId === StudyStatus.Complete) {
      this.study.status.name = CompleteStatus.Name;
      this.study.status.displayText = CompleteStatus.DisplayText;
      this.study.status.lookupId = CompleteStatus.LookupId;
      this.study.status.displayOrder = CompleteStatus.DisplayOrder;
    } else if (this.study.statusId === StudyStatus.InProgress) {
      this.study.status.name = InProgressStatus.Name;
      this.study.status.displayText = InProgressStatus.DisplayText;
      this.study.status.lookupId = InProgressStatus.LookupId;
      this.study.status.displayOrder = InProgressStatus.DisplayOrder;
    }

    this.studyStatusChanged();
    return this.study;
  }

  public async markStudyAsComplete(studyId: number, statusId: number): Promise<void> {
    await firstValueFrom(this.http.patch('/api/study/MarkStudyAsComplete', { studyId: studyId, statusId: statusId })).catch((e) => {
      this.logger.httpError(this.constructor.name, 'MarkStudyAsComplete', e);
      if (e.status === 401) {
        this.router.navigate(['nostudyaccess']);
      }
    });

    this.study.statusId = statusId;
    this.studyStatusChanged();
  }
}
